import { render } from "./Swiper.vue?vue&type=template&id=226e8211&scoped=true"
import script from "./Swiper.vue?vue&type=script&lang=js"
export * from "./Swiper.vue?vue&type=script&lang=js"

import "./Swiper.vue?vue&type=style&index=0&id=226e8211&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-226e8211"],['__file',"src/ui-components/Swiper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "226e8211"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('226e8211', __exports__)) {
    api.reload('226e8211', __exports__)
  }
  
  module.hot.accept("./Swiper.vue?vue&type=template&id=226e8211&scoped=true", () => {
    api.rerender('226e8211', render)
  })

}


export default __exports__